<ng-template #summary let-elements="elements">
  <div class="summary" *ngIf="elements.length > 0">
    <!-- <ng-oct-timeline [timelineElements]="tbdByCategory.value.timelineElements"></ng-oct-timeline> -->
    <mat-list>
      <mat-list-item *ngFor="let timelineElement of elements" [ngSwitch]="timelineElement.status">
        <mat-icon class="icon safe" *ngSwitchCase="'created'" svgIcon="add_circle_outline"></mat-icon>
        <mat-icon class="icon red" *ngSwitchCase="'deviation'" svgIcon="error"></mat-icon>
        <mat-icon class="icon safe" *ngSwitchCase="'remediated'" svgIcon="construction"></mat-icon>
        <span class="date">{{ timelineElement.date }} </span>
      </mat-list-item>
    </mat-list>
  </div>
</ng-template>

<div *ngIf="loaded && tenantBaselineDeviationsByCategory !== null" class="box">
  <div *ngFor="let category of tenantBaselineDeviationsByCategory | keyvalue; trackBy: trackByCategory" class="box">
    <b>{{ category.key }}</b>
    <mat-list class="baseline-container">
      <ng-container
        *ngFor="let tbdByCategory of tenantBaselineDeviationsByCategory[category.key] | keyvalue; trackBy: trackByName"
      >
        <div *ngIf="tbdByCategory.value !== null" class="baseline-content">
          <!-- baseline name (with deviations in timerange) -->
          <ng-container [ngSwitch]="tbdByCategory.value.status">
            <div *ngSwitchCase="'deviating'">
              <mat-icon class="critical" svgIcon="info-square"></mat-icon>
              {{ tbdByCategory.value.baseline_name }}

              <ng-container
                [ngTemplateOutlet]="summary"
                [ngTemplateOutletContext]="{ elements: tbdByCategory.value.timelineElements }"
              ></ng-container>
            </div>
            <!-- baseline name (deviated before timerange) -->
            <div *ngSwitchCase="'deviated'">
              <mat-icon class="critical" svgIcon="info-square"></mat-icon>
              {{ tbdByCategory.value.baseline_name }}
              <div class="summary">
                <p>
                  <mat-icon class="icon red" svgIcon="error"></mat-icon>
                  This baseline deviated before the selected time period
                </p>
              </div>
            </div>

            <ng-container
              *ngSwitchCase="'pass'"
              [ngTemplateOutlet]="safe"
              [ngTemplateOutletContext]="{ elements: tbdByCategory.value.timelineElements }"
            ></ng-container>
          </ng-container>
        </div>

        <ng-template #safe let-elements="elements">
          <div>
            <span class="icon">
              <mat-icon class="safe" svgIcon="done"></mat-icon>
              <!-- baseline name (without deviations) -->
              {{ tbdByCategory.value.baseline_name }}
              <ng-container
                [ngTemplateOutlet]="summary"
                [ngTemplateOutletContext]="{ elements: elements }"
              ></ng-container>
            </span>
          </div>
        </ng-template>
      </ng-container>
    </mat-list>
  </div>
</div>
